/*
 * @Author: Teemo Ding
 * @Date: 2021-02-05 11:40:52
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-18 14:24:34
 * @FilePath: /unifyxp-v2-store-portal/src/components/ExpandInput/ExpandInput.tsx
 */
import React from 'react';
import { Input } from 'src/components/Antd';
import css from './css.less';
const ExpandInput = (props) => {
  const {
    containerClassName,
    inputClassName,
    value = '',
    onChange,
    ...rest
  } = props;
  return (
    <div
      style={{ width: 180 + value.length * 10 }}
      className={css.container + ' ' + containerClassName || ''}>
      <Input
        value={value}
        onChange={onChange}
        className={css.input + ' ' + inputClassName || ''}
        {...rest}
      />
    </div>
  );
};
export default ExpandInput;
